import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';

import { booleanInputHandler } from './input.helpers';

const CheckboxWidget = props => {
	const { onChange, value, ...otherProps } = props;
	const handler = booleanInputHandler(onChange);
	return <Checkbox checked={value} onChange={handler} {...otherProps} />;
};

CheckboxWidget.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
};

export default CheckboxWidget;
